module.exports = __webpack_public_path__ + "static/media/AIRBNB.7b646785.svg";